"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const CrossCircleFilledIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-976.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(976.000000, 344.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          fill: color,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M11.5,10.0857864 L6.70710678,5.29289322 L6.61289944,5.20970461 C6.22060824,4.90467972 5.65337718,4.93240926 5.29289322,5.29289322 C4.90236893,5.68341751 4.90236893,6.31658249 5.29289322,6.70710678 L10.0857864,11.5 L5.29289322,16.2928932 L5.20970461,16.3871006 C4.90467972,16.7793918 4.93240926,17.3466228 5.29289322,17.7071068 C5.68341751,18.0976311 6.31658249,18.0976311 6.70710678,17.7071068 L11.5,12.9142136 L16.2928932,17.7071068 L16.3871006,17.7902954 C16.7793918,18.0953203 17.3466228,18.0675907 17.7071068,17.7071068 C18.0976311,17.3165825 18.0976311,16.6834175 17.7071068,16.2928932 L12.9142136,11.5 L17.7071068,6.70710678 L17.7902954,6.61289944 C18.0953203,6.22060824 18.0675907,5.65337718 17.7071068,5.29289322 C17.3165825,4.90236893 16.6834175,4.90236893 16.2928932,5.29289322 L11.5,10.0857864 Z M11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 Z",
            fillRule: "nonzero"
          })
        })
      })
    })
  })]
});

CrossCircleFilledIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = CrossCircleFilledIcon;
exports.default = _default;